<template>
  <vx-card class="editor-mid-card">
    <!-- <vue-perfect-scrollbar class="scroll-area" :settings="settings"> -->
    <div class="mb-base">
      <div class="flex justify-between flex-wrap mb-1">
        <vs-row vs-w="6">
          <h3 class="float-left mr-4">{{ $t("editor.contact.title") }}</h3>
          <vx-tooltip v-if="saveInProgress" text="Saving to cloud...">
            <feather-icon
              icon="CloudIcon"
              class="save-in-progress-status-icon"
              svgClasses="text-success"
          /></vx-tooltip>
          <vx-tooltip v-else :text="$t('editor.contact.saveToCloud')"
            ><feather-icon
              icon="CloudIcon"
              class="save-in-progress-status-icon"
          /></vx-tooltip>
        </vs-row>
        <div>
          <options
            :previousMove="{ name: 'editor-about' }"
            :nextMove="{ name: 'editor-career-history' }"
          />
        </div>
      </div>
      <p v-if="!isUserLoggedIn">
        <span v-if="organizationSlug === 'default'">
          {{ $t("editor.utils.notAuthenticated.youAreNotAuthenticated") }}
          <router-link :to="{ name: 'editor-about' }">{{
            $t("editor.utils.notAuthenticated.login")
          }}</router-link>
          {{ $t("editor.utils.notAuthenticated.toSaveYourData") }}
        </span>
        <span v-else>
          {{ $t("editor.utils.notAuthenticated.youAreNotAuthenticated") }}
          <router-link :to="{ name: 'editor-about-custom' }">{{
            $t("editor.utils.notAuthenticated.login")
          }}</router-link>
          {{ $t("editor.utils.notAuthenticated.toSaveYourData") }}
        </span>
      </p>
      <!-- <p v-if="!isUserLoggedIn" class="text-danger">
            You are not authenticated. Please login to save your data.
          </p>
          <p v-else-if="internetConnectionStatus">
            Internet Connection Active. Keep editing and your data gets auto-saved.
          </p>
          <p v-else class="text-danger">
            No Internet Connection. Please connect to Internet to save your data.
          </p> -->
    </div>
    <div class="main-form">
      <div class="vx-row">
        <div class="vx-col mb-2 md:mb-4 w-full md:w-1/2">
          <label>{{ $t("editor.contact.email") }}</label>
          <p v-if="isUserLoggedIn">{{ localData.email }}</p>
          <p v-else style="font-size: 12px">
            <span v-if="organizationSlug === 'default'">
              {{ $t("editor.contact.email_2.p1")
              }}<router-link :to="{ name: 'editor-about' }">{{
                $t("editor.contact.email_2.p2")
              }}</router-link>
            </span>
            <span v-else>
              {{ $t("editor.contact.email_2.p1")
              }}<router-link :to="{ name: 'editor-about' }">{{
                $t("editor.contact.email_2.p2")
              }}</router-link>
            </span>
          </p>
        </div>
        <div class="vx-col mb-2 md:mb-4 w-full md:w-1/2">
          <label>{{ $t("editor.contact.personalWebsite") }}</label>
          <vs-input
            class="w-full dark-input-field"
            name="Personal Website"
            maxlength="250"
            data-vv-validate-on="blur"
            v-validate="{ url: { require_protocol: true } }"
            :disabled="disableInputField"
            v-model="localData.personalWebsite"
            placeholder="https://www.website.com/"
            @blur="saveField('savePersonalWebsite', 'Personal Website')"
          />
          <span class="text-danger text-sm">{{
            errors.first("Personal Website")
          }}</span>
        </div>
      </div>
      <div class="vx-row flex flex-col-reverse md:flex-row">
        <div class="vx-col mt-6 w-full md:w-1/2">
          <div class="social-connect-btn flex items-center p-2 mb-4 md:mb-10">
            <div class="px-2">
              <img
                :src="
                  require(`@/assets/images/icons/social-icons/auth-slack.svg`)
                "
                alt=""
              />
            </div>
            <div class="flex cursor-pointer px-2" v-if="!isSlackVerified">
              <p class="pr-2" @click="verifySlack">Connect</p>
            </div>
            <div class="flex px-2" v-else>
              <p class="pr-2">
                {{ slackUserName }}
              </p>
              <img
                :src="require(`@/assets/images/icons/social-icons/check.svg`)"
                alt=""
              />
            </div>
          </div>
          <div class="social-connect-btn flex items-center p-2 mb-4 md:mb-10">
            <div class="px-2">
              <img
                :src="
                  require(`@/assets/images/icons/social-icons/auth-discord.svg`)
                "
                alt=""
              />
            </div>
            <div class="flex cursor-pointer px-2" v-if="!isDiscordVerified">
              <p class="pr-2" @click="verifyDiscord">Connect</p>
            </div>
            <div class="flex px-2" v-else>
              <p class="pr-2">
                {{ discordUserName }}
              </p>
              <img
                :src="require(`@/assets/images/icons/social-icons/check.svg`)"
                alt=""
              />
            </div>
          </div>
          <div class="social-connect-btn flex items-center p-2 mb-4 md:mb-10">
            <div class="px-2">
              <img
                :src="require(`@/assets/images/icons/social-icons/auth-fb.svg`)"
                alt=""
              />
            </div>
            <div class="flex cursor-pointer px-2" v-if="!isFbVerified">
              <p class="pr-2" @click="verifyFacebook">Connect</p>
            </div>
            <div class="flex px-2" v-else>
              <p class="pr-2">
                {{ fbUserName }}
              </p>
              <img
                :src="require(`@/assets/images/icons/social-icons/check.svg`)"
                alt=""
              />
            </div>
          </div>
          <div class="social-connect-btn flex items-center p-2 mb-4 md:mb-10">
            <div class="px-2">
              <img
                :src="
                  require(`@/assets/images/icons/social-icons/auth-linkedin.svg`)
                "
                alt=""
              />
            </div>
            <div class="flex cursor-pointer px-2" v-if="!isLinkedInVerified">
              <p class="pr-2" @click="verifyLinkedIn">Connect</p>
            </div>
            <div class="flex px-2" v-else>
              <p class="pr-2">
                {{ linkedInUserName }}
              </p>
              <img
                :src="require(`@/assets/images/icons/social-icons/check.svg`)"
                alt=""
              />
            </div>
          </div>
          <!-- <div class="social-connect-btn flex items-center p-2 mb-4 md:mb-10">
              <div class="px-2">
                <img :src="require(`@/assets/images/icons/social-icons/auth-twitter.svg`)" alt="">
              </div>
              <div class="flex cursor-pointer px-2">
                <p 
                  class="pr-2"
                  @click="verifyTwitter"
                >
                  Connect
                </p>
              </div>
            </div> -->
        </div>
        <div class="vx-col w-full md:w-1/2">
          <div class="mb-2 md:mb-4">
            <label>{{ $t("editor.contact.contactNumber") }}</label>
            <vs-input
              class="w-full mb-1 dark-input-field"
              name="Contact Number"
              maxlength="15"
              data-vv-validate-on="blur"
              v-validate="{
                regex:
                  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
              }"
              :disabled="disableInputField"
              v-model="localData.contactNumber"
              @blur="saveField('saveContactNumber', 'Contact Number')"
            />
            <span class="text-danger text-sm">{{
              errors.first("Contact Number")
            }}</span>
          </div>
          <div class="mb-2 md:mb-4">
            <label>{{ $t("editor.contact.address") }}</label>
            <vs-input
              class="w-full dark-input-field"
              name="Address"
              maxlength="220"
              data-vv-validate-on="blur"
              :disabled="disableInputField"
              v-model="localData.address"
              @blur="saveField('saveAddress')"
            />
          </div>
          <div class="mb-2 md:mb-4">
            <label>{{ $t("editor.contact.skypeProfile") }}</label>
            <vs-input
              class="w-full dark-input-field"
              name="Skype Profile"
              maxlength="250"
              data-vv-validate-on="blur"
              v-validate="{
                url: { require_protocol: true },
                regex: /https:\/\/join\.skype\.com\/invite\/[A-Za-z0-9]+/,
              }"
              :disabled="disableInputField"
              v-model="localData.skypeProfile"
              @blur="saveField('saveSkypeProfile', 'Skype Profile')"
            />
            <span class="text-danger text-sm">{{
              errors.first("Skype Profile")
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- </vue-perfect-scrollbar> -->
  </vx-card>
</template>

<script>
import FeatherIcon from "../../components/FeatherIcon.vue";
import Options from "./components/Options.vue";
// import axios from '@/axios.js';
import constants from "@/constants";
import { saveInputFieldService } from "@/services/editor/contact.service.js";
// import _ from "lodash";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: { FeatherIcon, Options, VuePerfectScrollbar },
  name: "EditorContact",
  data() {
    return {
      localData: {},
      constants,
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
      },
    };
  },
  computed: {
    otpSent() {
      return this.$store.state.auth.otpSent;
    },
    saveInProgress() {
      return this.$store.state.editor.saveInProgress;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    usersData() {
      return this.$store.state.users.data;
    },
    userId() {
      return this.$store.state.auth.user._id;
    },
    fbUserName() {
      return this.$store.state.socialAuth.fbData.username;
    },
    isFbVerified() {
      return this.$store.state.socialAuth.isFbVerified;
    },
    slackUserName() {
      return this.$store.state.socialAuth.slackData.username;
    },
    isSlackVerified() {
      return this.$store.state.socialAuth.isSlackVerified;
    },
    discordUserName() {
      return this.$store.state.socialAuth.discordData.username;
    },
    isDiscordVerified() {
      return this.$store.state.socialAuth.isDiscordVerified;
    },
    linkedInUserName() {
      return this.$store.state.socialAuth.linkedInData.username;
    },
    isLinkedInVerified() {
      return this.$store.state.socialAuth.isLinkedInVerified;
    },
    internetConnectionStatus() {
      return this.$store.state.users.internetConnectionStatus;
    },
    disableInputField() {
      return !this.isUserLoggedIn || !this.internetConnectionStatus;
    },
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
  },
  watch: {
    usersData(newVal) {
      if (newVal) {
        //// console.log(newVal);
        this.localData = JSON.parse(JSON.stringify(newVal));
      }
    },
  },
  methods: {
    verifyFacebook() {
      const clientId = "1551523535423367";
      const redirectUri = `https://editor.getboarded.com/contact-v2?authType=fbAuth`;
      const url = `https://www.facebook.com/v12.0/dialog/oauth?client_id=${clientId}&redirect_uri=${redirectUri}`;
      window.location.href = url;
    },
    getFaceBookData() {
      this.$store.dispatch("socialAuth/getFaceBookData", {
        userId: this.userId,
      });
    },
    verifySlack() {
      const clientId = "5316349728481.6954774661440";
      const redirect_uri = `https://editor.getboarded.com/contact-v2?authType=slackAuth`;
      const scope = "identity.basic,identity.email";
      const url = `${constants.slackUrl}/oauth/v2/authorize?client_id=${clientId}&redirect_uri=${redirect_uri}&user_scope=${scope}`;
      window.location.href = url;
    },
    getSlackData() {
      this.$store.dispatch("socialAuth/getSlackData", { userId: this.userId });
    },
    verifyDiscord() {
      const clientId = "1091377219231813642";
      const redirect_uri = `https://editor.getboarded.com/contact?authType=discordAuth`;
      const encodedURL = encodeURIComponent(redirect_uri);
      const url = `${constants.discordApi}/oauth2/authorize?client_id=${clientId}&redirect_uri=${encodedURL}&response_type=code&scope=identify`;
      window.location.href = url;
    },
    getDiscordData() {
      this.$store.dispatch("socialAuth/getDiscordData", {
        userId: this.userId,
      });
    },
    verifyLinkedIn() {
      const client_id = "86u02qqn1xhmqe";
      const state = "760iz0bjh9gy71asfFqa";
      const redirectUri = encodeURIComponent(
        `https://editor.getboarded.com/contact-v2?authType=linkedInAuth`
      );
      const url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${client_id}&redirect_uri=${redirectUri}&state=${state}&scope=r_liteprofile,r_emailaddress`;
      window.location.href = url;
    },
    getLinkedInData() {
      this.$store.dispatch("socialAuth/getLinkedInData", {
        userId: this.userId,
      });
    },
    verifyTwitter() {
      const twitterReqToken = this.requestToken;
      const url = `${constants.twitterApi}/authorize?${twitterReqToken}`;
      window.location.href = url;
    },
    // async getTwitterRequestToken(){
    //   try {
    //     const response = await axios.get(`https://twitter-api-test.onrender.com/token`);
    //     const twitterReqToken = response.data;
    //     this.requestToken = twitterReqToken;
    //     return twitterReqToken;
    //   } catch (error) {
    //     throw error;
    //   }
    // },
    // Function to get the org name
    getOrgSlug() {
      const url = window.location.href;
      const pathname = new URL(url).pathname;      
      if (pathname === "/contact-v2") {
        sessionStorage.setItem("activeOrgSlug", null);
      }
      else if (pathname.startsWith("/") && pathname.endsWith("/contact-v2")) {
        const orgSlug = pathname.split('/')[1];
        sessionStorage.setItem("activeOrgSlug", orgSlug);
      }
    },    
    getActiveOrg(){
      const url = window.location.href;
      const slug = sessionStorage.getItem("activeOrgSlug");
      if(slug === "gala") {
        this.$store.dispatch("organization/fetchOrganizationBySlug", slug);
        const newUrl = url.replace("https://editor.getboarded.com/contact-v2", "https://editor.getboarded.com/" + slug + "/contact-v2");
        window.location.href = newUrl;
      }
    },
    checkSocialProfiles() {},
    async saveField(action, fieldName = null) {
      let fieldIsValid = false;

      if (fieldName) {
        fieldIsValid = await this.$validator.validate(fieldName);

        if (!fieldIsValid) {
          return;
        }
      } else {
        fieldIsValid = true;
      }

      //// console.log(fieldIsValid);

      if (fieldName && !fieldIsValid) {
        return;
      }

      const payload = {
        isUserLoggedIn: this.isUserLoggedIn,
        action,
        localData: this.localData,
        userId: this.userId,
        currentThis: this,
      };

      saveInputFieldService(payload);
    },
  },
  mounted() {
    this.getOrgSlug();
    this.getSlackData();
    this.getDiscordData();
    this.getFaceBookData();
    this.getLinkedInData();
    // this.getTwitterRequestToken();
  },
  created() {
    this.getActiveOrg();
    this.$store.dispatch("editor/toggleRightBar", true);
    this.$store.dispatch("editor/togglePreviewMode", false);
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    const authType = searchParams.get("authType");
    const oAuthToken = searchParams.get("oauth_token");
    const oAuthVerifier = searchParams.get("oauth_verifier");
    if (code && authType === "fbAuth") {
      this.$store.dispatch("socialAuth/handleFacebookCallback", {
        code,
        userId: this.userId,
      });
    } else if (code && authType === "slackAuth") {
      this.$store.dispatch("socialAuth/handleSlackCallback", {
        code,
        userId: this.userId,
      });
    } else if (code && authType === "discordAuth") {
      this.$store.dispatch("socialAuth/handleDiscordCallback", {
        code,
        userId: this.userId,
      });
    } else if (code && authType === "linkedInAuth") {
      this.$store.dispatch("socialAuth/handleLinkedInCallback", {
        code,
        userId: this.userId,
      });
    } else if (oAuthToken && oAuthVerifier) {
      this.$store.dispatch("socialAuth/handleTwitterCallback", {
        oAuthToken,
        oAuthVerifier,
      });
    }

    //// console.log("contact created");

    if (this.isUserLoggedIn) {
      if (Object.keys(this.usersData).length) {
        this.localData = JSON.parse(JSON.stringify(this.usersData));
        //// console.log(this.localData);
      }
    }
  },
};
</script>

<style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 615px;
  /*height: 1000px;*/
}
.email {
  font-size: 1em;
  word-wrap: break-word;
}
.dark-input-field >>> .vs-con-input .vs-input--input {
  background: #edededab !important;
}
.vs-con-textarea >>> .vs-textarea {
  background: #edededab !important;
}
</style>
